module.exports = __webpack_public_path__ + "img/home_icon_chanping.3a10ae88.png";